module.exports = __webpack_public_path__ + "img/exclamation-mark-red.c8a6ddbd.svg";